import { useEffect, useState } from 'react';
import { getPromotions } from '../../actions/promotion';
import { formatDate } from '../../helpers/formatDate';
import InnerLoader from '../../Components/Common/InnerLoader';

import {
  Modal,
  ModalBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Button,
} from 'reactstrap';
import PromotionDetail from './PromotionDetail';
import { Else, If, Then } from 'react-if';
import CustomPagination from './CustomPagination';
import { formatDistanceToNow } from 'date-fns';
import { getInitials } from '../../utils/misc';
import { useParams } from 'react-router-dom';

const PromotionTable = ({ selectedSortBy = null, selectedFillers = null }) => {
  const [data, setData] = useState([]);
  const [showPromotionDetail, setPromotionDetailOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pageOffset, setPageOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [direction] = useState('down');
  const [showModal, setShowModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);

  const { campaignTypeId } = useParams();

  const toggleDropdown = (itemId) => {
    setDropdownOpen((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };
  const handleActionClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  const getPromotionsFunc = async () => {
    setLoading(true);

    const variables = {
      input: {
        pageOffset: pageOffset,
        pageSize: pageSize,
        filters: {
          ...(selectedFillers || {}),
          'basicSettings.campaignType': campaignTypeId
            ? campaignTypeId?.toUpperCase()?.replaceAll('-', '_')
            : null,
        },
        sortBy: selectedSortBy,
      },
    };
    const { data } = await getPromotions(variables);

    setTimeout(() => {
      setData(data?.promotions || []);
      setTotalPages(data?.totalPages);
      setLoading(false);
    }, 400);
  };

  useEffect(() => {
    getPromotionsFunc();
  }, [pageOffset]);

  useEffect(() => {
    if (pageOffset === 0) {
      getPromotionsFunc();
    } else {
      setPageOffset(0);
    }
  }, [selectedFillers, selectedSortBy, campaignTypeId]);

  document.title = 'Promotion List';

  return (
    <>
      <Modal
        size="xxl"
        className="modal-right"
        isOpen={showPromotionDetail}
        toggle={() => {
          window.history?.back();
          setPromotionDetailOpen(!showPromotionDetail);
        }}
      >
        {/* <ModalHeader toggle={() => setOpen(!open)}>Delete Customer</ModalHeader> */}
        <ModalBody>
          <If condition={showPromotionDetail}>
            <Then>
              <div style={{ overflowY: 'scroll' }}>
                <PromotionDetail
                  promotionIdFromPopup={showPromotionDetail}
                  isPopup
                />
              </div>
            </Then>
          </If>
        </ModalBody>
      </Modal>

      <div className="position-relative d-flex flex-column">
        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light fs-14">
            <tr>
              <th>Details</th>
              <th>Country</th>
              <th>Status</th>
              <th>Last Updated</th>
              <th>Report</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody className="fs-13">
            {(data || []).map((item, key) => (
              <tr>
                <td>
                  <div className="d-flex gap-2">
                    <span
                      className="bg-dark-subtle p-2 rounded-2 opacity-25 fs-42"
                      style={{ fontSize: 42 }}
                    >
                      <If condition={item.triggerType === 'autoapply'}>
                        <Then>
                          <i className="ri-compass-discover-line text-info"></i>
                        </Then>
                        <Else>
                          <i className="bx bxs-discount text-info"></i>
                        </Else>
                      </If>
                    </span>
                    <div className="d-flex flex-column gap-1">
                      <p className="m-0 fs-14 fw-medium">
                        <a
                          href={`/promotions/${campaignTypeId}/detail/${item?._id}/basic`}
                          className="text-dark"
                        >
                          {item?.basicSettings?.promotionName}
                        </a>
                      </p>
                      {item?.couponApply?.length ? (
                        <div className="d-flex flex-wrap align-items-center gap-1">
                          <p className="m-0 d-flex flex-wrap align-items-center gap-1 fs-11 text-muted fw-normal">
                            <span className="d-flex flex-wrap align-items-center gap-1">
                              {item?.couponApply?.map((sItem, index) => (
                                <span
                                  key={`cp-${index}`}
                                  className={`badge rounded-pill bg-soft-${sItem?.className} text-${sItem?.className}`}
                                >
                                  {sItem?.label}
                                </span>
                              ))}
                            </span>
                          </p>
                        </div>
                      ) : null}
                      <div className="d-flex flex-wrap align-items-center gap-1">
                        <p className="m-0 fs-11 text-muted">
                          Start Date :{' '}
                          <strong className="text-dark">
                            {item?.launcher?.startDate
                              ? formatDate(item?.launcher?.startDate)
                              : '-'}
                          </strong>
                        </p>
                        <span className="fs-12 text-muted">|</span>
                        <p className="m-0 fs-11 text-muted">
                          End Date :{' '}
                          <strong className="text-dark">
                            {item?.launcher?.endDate
                              ? formatDate(item?.launcher?.endDate)
                              : '-'}
                          </strong>
                        </p>
                      </div>

                      {item?.basicSettings?.tags?.length ? (
                        <div className="d-flex flex-wrap align-items-center gap-1">
                          <p className="m-0 d-flex flex-wrap align-items-center gap-1 fs-11 text-muted fw-normal">
                            Tag:
                            <span className="d-flex flex-wrap align-items-center gap-1">
                              {item?.basicSettings?.tags?.map(
                                (tag, tagIndex) => {
                                  return (
                                    <span
                                      key={`tag-${tagIndex}`}
                                      className={`badge rounded-pill bg-primary-subtle text-primary`}
                                    >
                                      {tag}
                                    </span>
                                  );
                                }
                              )}
                            </span>
                          </p>
                        </div>
                      ) : null}
                      <div className="d-flex flex-wrap align-items-center gap-1">
                        <p className="m-0 fs-11 text-muted">
                          Trigger Type :{' '}
                          <strong className="text-dark">
                            {item.triggerType === 'autoapply'
                              ? 'Auto Applied'
                              : 'By Applying Coupon Code'}
                          </strong>
                        </p>
                        <span className="fs-12 text-muted">|</span>
                        <p className="m-0 fs-11 text-muted">
                          Effects :{' '}
                          <strong className="text-dark">Discount</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  {item?.basicSettings?.country?.length ? (
                    <span className="d-flex flex-wrap align-items-center gap-1">
                      {item?.basicSettings?.country?.map((country, index) => (
                        <span
                          key={`c-${index}`}
                          className={`badge rounded-pill text-primary bg-primary-subtle`}
                        >
                          {country}
                        </span>
                      ))}
                    </span>
                  ) : null}
                </td>
                <td>
                  {item?.status === 'published' ||
                  item?.status === 'paused' ||
                  item?.status === 'expired' ||
                  item?.status === 'unpublished' ? (
                    <span
                      className={`badge ${
                        item.status === 'paused' ||
                        item?.status === 'expired' ||
                        item?.status === 'unpublished'
                          ? 'bg-danger'
                          : 'bg-success'
                      } text-capitalize`}
                    >
                      {item?.status}
                      <span className="text-lowercase">{` - v${item?.version}`}</span>
                    </span>
                  ) : (
                    <div className="d-flex flex-column gap-1 w-auto">
                      <span
                        className={`badge ${
                          item.status === 'paused' ? 'bg-danger' : 'bg-primary'
                        } text-capitalize d-flex`}
                        style={{ width: 'fit-content' }}
                      >
                        {item?.status}
                      </span>
                      <span
                        className="badge bg-success text-capitalize d-flex"
                        style={{ width: 'fit-content' }}
                      >
                        Published
                        <span className="text-lowercase ps-1">{`- v${item?.version}`}</span>
                      </span>
                    </div>
                  )}
                </td>
                <td>
                  <div className="d-flex flex-column gap-1">
                    <div className="d-flex gap-2 align-items-center">
                      <span
                        className="member rounded-circle bg-white position-relative"
                        style={{ width: 26, height: 26 }}
                      >
                        <span className="d-flex justify-content-center align-items-center rounded-circle bg-dark-subtle text-dark w-100 h-100 fs-10">
                          {getInitials(item?.updatedByName)}
                        </span>
                      </span>
                      <p className="mb-0 text-wrap">{item?.updatedByName}</p>
                    </div>
                    <span>
                      {item.updatedAt &&
                        formatDistanceToNow(new Date(item.updatedAt), {
                          addSuffix: true,
                        })}
                    </span>
                  </div>
                </td>

                <td>
                  <div className="d-flex flex-column gap-1">
                    <p className="m-0 fs-11 text-muted">
                      Revenue :{' '}
                      <strong className="text-dark">
                        <strong className="fw-bold m-0">
                          {(
                            item?.reports?.promotionDuration?.revenue || 0
                          ).toFixed(2)}{' '}
                          AED
                        </strong>
                      </strong>
                    </p>
                    <p className="m-0 fs-11 text-muted">
                      Spends :{' '}
                      <strong className="text-dark">
                        <strong className="fw-bold m-0">
                          {(
                            item?.reports?.promotionDuration?.spends || 0
                          ).toFixed(2)}{' '}
                          AED
                        </strong>
                      </strong>
                    </p>
                    <p className="m-0 fs-11 text-muted">
                      No. of Transactions :{' '}
                      <strong className="text-dark">
                        <strong className="fw-bold m-0">
                          {item?.reports?.promotionDuration?.noOfTransactions ||
                            0}
                        </strong>
                      </strong>
                    </p>
                  </div>
                </td>

                <td>
                  <Dropdown
                    isOpen={dropdownOpen[item?._id]}
                    toggle={() => toggleDropdown(item?._id)}
                    direction={direction}
                  >
                    <DropdownToggle className="bg-transparent border-0 p-0 shadow-none text-dark ms-auto">
                      <i className="bx bx-dots-horizontal-rounded fs-20"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        className="fs-13 d-flex align-items-center gap-1"
                        onClick={() =>
                          handleActionClick(
                            `/promotions/${campaignTypeId}/detail/${item?._id}/basic`
                          )
                        }
                      >
                        <i className="bx bx-pencil"></i>
                        Edit
                      </DropdownItem>
                      <DropdownItem
                        className="fs-13 d-flex align-items-center gap-1 text-danger"
                        onClick={() => {
                          setSelectedAction(item?._id);
                          setShowModal(true);
                        }}
                      >
                        <i className="bx bx-trash"></i>
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <CustomPagination
        pageOffset={pageOffset}
        totalPages={totalPages}
        setPageOffset={setPageOffset}
      />

      {loading ? <InnerLoader /> : null}

      <Modal
        isOpen={showModal}
        toggle={() => setShowModal(false)}
        backdrop="static"
      >
        <div className="modal-header border-bottom">
          <h6 className="modal-title">Confirm Deletion</h6>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          Are you sure you want to delete this item?
        </div>
        <div className="modal-footer">
          <Button
            size="sm"
            outline
            color="dark"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            outline
            color="danger"
            // onClick={handleConfirmDelete}
          >
            Delete
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default PromotionTable;
